<template>
  <div class="">
    <canvas
      id="croppImgCanvas"
      ref="croppImgCanvas"
      class="croppImgCanvas"
      :class="{ 'disable-canvas': modalActive }"
      :width="canvasWidth"
      :height="canvasHeight"
    >
    </canvas>
    <canvas
      id="croppImgTextMarkerCanvas"
      ref="croppImgTextMarkerCanvas"
      class="croppImgTextMarkerCanvas"
      :class="{ 'disable-canvas': modalActive }"
      :style="'opacity:' + croppImgTextMarkerCanvasOpacity + ';'"
      :width="canvasWidth"
      :height="canvasHeight"
      @mousedown="handleMouseDown"
      @touchstart="handleMouseDown"
      @mouseup="handleMouseUp"
      @touchend="handleMouseUp"
      @mousemove="handleMouseMove"
      @touchmove="handleMouseMove"
      v-show="croppImgTextMarkerCanvasActive"
    >
    </canvas>
    <canvas
      id="croppImgTempCanvas"
      ref="croppImgTempCanvas"
      class="croppImgTempCanvas"
      :class="{ 'disable-canvas': modalActive }"
      :width="canvasWidth"
      :height="canvasHeight"
      @mousedown="handleMouseDown"
      @touchstart="handleMouseDown"
      @mouseup="handleMouseUp"
      @touchend="handleMouseUp"
      @mouseleave="handleMouseUp"
      @mousemove="handleMouseMove"
      @touchmove="handleMouseMove"
      v-show="canvasActive"
    >
    </canvas>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'tr-canvas',
  data: function() {
    return {
      ctx: null,
      mouse: {
        current: {
          x: 0,
          y: 0,
        },
        previous: {
          x: 0,
          y: 0,
        },
        down: false,
      },
    };
  },
  components: {},
  mounted: function() {
    let $bbBlock = $('.bb-bookblock');
    let mainCanvas = this.$refs.croppImgCanvas;
    this.mainCanvas = mainCanvas;
    this.croppImgTextMarkerCanvas = this.$refs.croppImgTextMarkerCanvas;
    this.mainCtx = mainCanvas.getContext('2d');
    // let container = mainCanvas.parentNode;
    let croppImgTempCanvas = this.$refs.croppImgTempCanvas;
    this.canvas = croppImgTempCanvas;
    this.ctx = croppImgTempCanvas.getContext('2d');
    this.textCtx = croppImgTextMarkerCanvas.getContext('2d');
  },
  methods: {
    getTool() {
      return this.$store.getters.tool;
    },
    imgUpdate() {
      if (this.$store.getters.tool === 'eraser') {
        this.mainCtx.globalCompositeOperation = 'destination-out';
      } else if (this.$store.getters.tool === 'textMarker') {
        this.mainCtx.globalCompositeOperation = 'source-over';
        // this.mainCtx.globalCompositeOperation = "lighter";
      } else {
        this.mainCtx.globalCompositeOperation = 'source-over';
      }
      this.mainCtx.drawImage(this.canvas, 0, 0);
      if (this.$store.getters.tool === 'textMarker') {
        // this.textCtx.globalAlpha = this.croppImgTextMarkerCanvasOpacity;
        this.mainCtx.globalAlpha = this.croppImgTextMarkerCanvasOpacity;
        this.mainCtx.drawImage(this.croppImgTextMarkerCanvas, 0, 0);
        this.textCtx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      } else {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      }
    },
    drawLine() {
      if (this.mouse.down) {
        this.ctx.strokeStyle = this.$store.getters.toolColor;
        this.ctx.lineTo(this.currentMouse.x, this.currentMouse.y);
        this.ctx.lineWidth = this.$store.getters.toolSize;
        this.ctx.lineCap = 'round';
        this.ctx.stroke();
      }
    },
    textMarker() {
      if (this.mouse.down) {
        // this.ctx.globalAlpha = 0.1;
        // this.mainCtx.globalAlpha = 0.01;
        this.textCtx.strokeStyle = this.$store.getters.toolColor;
        // this.textCtx.strokeStyle = 'rgba(100,10,100,0.3)';
        this.textCtx.lineTo(this.currentMouse.x, this.currentMouse.y);
        this.textCtx.lineWidth = this.$store.getters.toolSize;
        this.textCtx.lineCap = 'round';
        this.textCtx.stroke();
      }
    },
    drawCircle() {
      if (this.mouse.down) {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        //Save
        this.ctx.save();
        this.ctx.beginPath();
        let scalex = 1 * ((this.currentMouse.x - this.mouse.previous.x) / 2);
        let scaley = 1 * ((this.currentMouse.y - this.mouse.previous.y) / 2);
        this.ctx.scale(scalex, scaley);
        //Create ellipse
        let centerx = this.mouse.previous.x / scalex + 1;
        let centery = this.mouse.previous.y / scaley + 1;
        this.ctx.arc(centerx, centery, 1, 0, 2 * Math.PI);
        //Restore and draw
        this.ctx.restore();
        this.ctx.strokeStyle = this.$store.getters.toolColor;
        this.ctx.lineWidth = this.$store.getters.toolSize;
        this.ctx.stroke();
      }
    },
    drawRectangle() {
      if (this.mouse.down) {
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.$store.getters.toolColor;
        this.ctx.lineWidth = this.$store.getters.toolSize;
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        this.ctx.moveTo(this.currentMouse.x, this.currentMouse.y);
        let width = this.currentMouse.x - this.mouse.previous.x;
        let height = this.currentMouse.y - this.mouse.previous.y;
        this.ctx.rect(this.mouse.previous.x, this.mouse.previous.y, width, height);
        this.ctx.stroke();
      }
    },
    handleMouseDown(event) {
      let pointer;
      event.preventDefault();
      this.imgUpdate();
      if (this.tool === 'textMarker') {
        this.textCtx.beginPath();
      } else {
        this.ctx.beginPath();
      }
      this.mouse.down = true;
      pointer = event;
      if (event.type === 'touchstart' && event.touches && event.touches[0]) {
        pointer = event.touches[0];
      }
      this.mouse.current = {
        x: pointer.pageX,
        y: pointer.pageY,
      };
      this.mouse.previous = {
        x: this.currentMouse.x,
        y: this.currentMouse.y,
      };
      this.mouse.previous = {
        x: this.currentMouse.x,
        y: this.currentMouse.y,
      };
      if (this.tool === 'textMarker') {
        this.textCtx.moveTo(this.currentMouse.x, this.currentMouse.y);
      } else {
        this.ctx.moveTo(this.currentMouse.x, this.currentMouse.y);
      }
    },
    handleMouseUp(event) {
      event.preventDefault();
      this.mouse.down = false;
      this.imgUpdate();
      let pointer = event;
      if (event.type === 'touchend' && event.touches && event.touches[0]) {
        pointer = event.touches[0];
      }
      this.mouse.previous = {
        x: pointer.pageX,
        y: pointer.pageY,
      };
    },
    handleMouseMove(event) {
      event.preventDefault();
      let pointer = event;
      if (event.type === 'touchmove' && event.touches && event.touches[0]) {
        pointer = event.touches[0];
      }
      this.mouse.current = {
        x: pointer.pageX,
        y: pointer.pageY,
      };
      switch (this.tool) {
        case 'textMarker':
          this.textMarker();
          // this.ctx.globalAlpha = 0.3;
          // this.mainCtx.globalAlpha = 0.3;
          break;
        case 'rectangle':
          this.mainCtx.globalAlpha = 1;
          this.drawRectangle();
          break;
        case 'circle':
          this.mainCtx.globalAlpha = 1;
          this.drawCircle();
          break;
        case 'paintBrush':
        case 'eraser':
        default:
          this.drawLine();
          this.imgUpdate();
      }
    },
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },
  },
  computed: {
    canvasWidth() {
      return this.$store.getters.canvasWidth;
    },
    canvasHeight() {
      return this.$store.getters.canvasHeight;
    },
    canvasTop() {
      return this.$store.getters.canvasTop;
    },
    canvasLeft() {
      return this.$store.getters.canvasLeft;
    },
    currentMouse() {
      let rect = this.$refs.croppImgCanvas.getBoundingClientRect();
      let x = (this.mouse.current.x - rect.left) / this.$store.getters.scale;
      let y = (this.mouse.current.y - rect.top) / this.$store.getters.scale;
      return {
        x,
        y,
      };
    },
    color() {
      return this.$store.getters.toolColor;
    },
    size() {
      return this.$store.getters.toolSize;
    },
    tool() {
      return this.$store.getters.tool;
    },
    canvasActive() {
      return this.$store.getters.canvasActive;
    },
    croppImgTextMarkerCanvasActive() {
      return this.$store.getters.textMarkerCanvasActive;
    },
    croppImgTextMarkerCanvasOpacity() {
      return this.$store.getters.textMarkerCanvasOpacity;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>

<style lang="scss" scoped>
#croppImgCanvas,
#croppImgTempCanvas,
#croppImgTextMarkerCanvas {
  position: absolute;
  pointer-events: auto;

  transform: translateX(-50%);
  z-index: 1250;
  cursor: crosshair;
}
#croppImgTextMarkerCanvas {
  z-index: 1251;
}
#croppImgCanvas {
  z-index: 1110;
  cursor: default;
  pointer-events: none;
}
.disable-canvas {
  pointer-events: none;
  display: none;
}
</style>
